var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { id: "card-zoom", type: "flex", justify: "center" } },
        [
          _c(
            "el-col",
            { attrs: { span: 2 } },
            [
              _c(
                "el-button",
                {
                  staticClass: "zoomOut",
                  attrs: { id: "iconZoom" },
                  on: { click: _vm.zoomOut }
                },
                [_c("i", { staticClass: "fal fa-search-minus" })]
              )
            ],
            1
          ),
          _c("el-col", { attrs: { span: 2 } }, [
            _c("h3", { staticClass: "zoom" }, [
              _vm._v(_vm._s(this.scaleZoomPorcentagem) + "%")
            ])
          ]),
          _c(
            "el-col",
            { attrs: { span: 2 } },
            [
              _c(
                "el-button",
                {
                  staticClass: "zoomIn",
                  attrs: { id: "iconZoom" },
                  on: { click: _vm.zoomIn }
                },
                [_c("i", { staticClass: "fal fa-search-plus" })]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 2 } },
            [
              _c(
                "el-button",
                {
                  staticClass: "rotateLeft",
                  attrs: { id: "iconZoom" },
                  on: { click: _vm.rotateLeft }
                },
                [_c("i", { staticClass: "fal fa-undo-alt" })]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 2 } },
            [
              _c(
                "el-button",
                {
                  staticClass: "rotateRight",
                  attrs: { id: "iconZoom" },
                  on: { click: _vm.rotateRight }
                },
                [_c("i", { staticClass: "fal fa-redo-alt" })]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "card-info",
          style: _vm.customStyle || {},
          attrs: { id: "image", shadow: "hover" }
        },
        [_vm._m(0)],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "app-vue-perfect-scrollbar",
      { staticClass: "scroll-area", attrs: { settings: _vm.settings } },
      [
        _c("div", [
          _c("img", { attrs: { id: "img", src: _vm.imgUrl(_vm.bytes) } })
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0821ce9c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0821ce9c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppImageViewer.vue
// module id = null
// module chunks = 